<template>
  <span class="standard-cube-icon" :style="iconStyle" aria-hidden="true">
    <!-- 与 Ant Design CodeSandboxOutlined 一致（项目未装 @ant-design/icons-vue，用内联 SVG） -->
    <svg viewBox="64 64 896 896" focusable="false" width="1em" height="1em" fill="currentColor">
      <path
        d="M709.6 210l.4-.2h.2L512 96 313.9 209.8h-.2l.7.3L151.5 304v416L512 928l360.5-208V304l-162.9-94zM482.7 843.6L339.6 761V621.4L210 547.8V372.9l272.7 157.3v313.4zM238.2 321.5l134.7-77.8 138.9 79.7 139.1-79.9 135.2 78-273.9 158-274-158zM574 361.8l-44-25.4-44 25.4-44-25.4-44 25.4 88 50.8 88-50.8zm166 186l-129.6 73.6v139.6l-143.1 82.6V530.2l272.7-157.3v174.9z"
      />
    </svg>
  </span>
</template>

<script>
export default {
  name: 'StandardCubeIcon',
  props: {
    size: { type: [Number, String], default: 22 },
  },
  computed: {
    iconStyle() {
      const px = typeof this.size === 'number' ? `${this.size}px` : this.size
      return { fontSize: px }
    },
  },
}
</script>

<style scoped>
.standard-cube-icon {
  display: inline-flex;
  align-items: center;
  line-height: 0;
}
</style>
